import { useCallback } from "react";
import { Button, Flex, ModalV2 } from "@jsq/ds/core";
import { SPACING } from "~/styles/variables";

type QueryUnsavedChangesModalProps = {
  show: boolean;
  isSaving?: boolean;
  onKeepEditing: () => void;
  onDiscard: () => void;
  onSave: () => void | Promise<void>;
};

export const QueryUnsavedChangesModal = ({
  show,
  isSaving = false,
  onKeepEditing,
  onDiscard,
  onSave,
}: QueryUnsavedChangesModalProps) => {
  const handleHide = useCallback(() => {
    if (isSaving) return;
    onKeepEditing();
  }, [isSaving, onKeepEditing]);

  return (
    <ModalV2
      show={show}
      onHide={handleHide}
      title="Unsaved changes"
      size="small"
      isCentered
      closeOnClickOutside={!isSaving}
      escapeToClose={!isSaving}
      closeButton={!isSaving}
      data-testid="discard-modal"
      description="You have unsaved changes. Do you want to save them before leaving?"
    >
      <ModalV2.Body>
        <Flex justifyContent="flex-end" gap={SPACING.SMALL}>
          <Button
            variant="neutral"
            onClick={onDiscard}
            disabled={isSaving}
            data-testid="discard-btn"
          >
            Discard changes
          </Button>
          <Button
            variant="primary"
            onClick={() => void onSave()}
            isLoading={isSaving}
            disabled={isSaving}
            data-testid="save-btn"
          >
            Save changes
          </Button>
        </Flex>
      </ModalV2.Body>
    </ModalV2>
  );
};
